import { render, staticRenderFns } from "./CreateBatchPick.vue?vue&type=template&id=c6af6b2e&"
import script from "./CreateBatchPick.vue?vue&type=script&lang=js&"
export * from "./CreateBatchPick.vue?vue&type=script&lang=js&"
import style0 from "./CreateBatchPick.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports